// Editorial section header — thin rule lines on either side of the title.
// Inspired by the "AI Edits" / "Scenes" headers from the Mody reference.
import { cn } from "@/lib/utils";

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
  className?: string;
}

export const SectionHeader = ({ title, subtitle, action, className }: SectionHeaderProps) => {
  return (
    <div className={cn("mb-3 mt-6 flex items-end justify-between gap-3", className)}>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <span className="h-px w-6 bg-primary/60" />
          <h2 className="font-display text-[11px] font-semibold uppercase tracking-[0.28em] text-primary">
            {title}
          </h2>
        </div>
        {subtitle && (
          <p className="mt-1 truncate text-[13px] text-muted-foreground">{subtitle}</p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
};
